var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-history-chart",class:{
    'profile-history-chart--compact': _vm.compact,
    'profile-history-chart--legacy': _vm.legacyLayout,
  }},[_c('div',{ref:"chartContainer",staticClass:"profile-history-chart-container",attrs:{"id":_vm.chartContainerId}},[_c('canvas',{attrs:{"id":_vm.chartCanvasId}})])])}
var staticRenderFns = []

export { render, staticRenderFns }